__turbopack_context__.v({
  "className": "bricolage_grotesque_23360a62-module__YSngIW__className",
});
